import { Component } from '@angular/core';

import { PageHeaderComponent } from '../../../shared/ui/page-header/page-header.component';
import { AppointmentCreateFlowComponent } from '../components/appointment-create-flow.component';

@Component({
  selector: 'app-appointment-client-intent-map-page',
  standalone: true,
  imports: [
    PageHeaderComponent,
    AppointmentCreateFlowComponent,
  ],
  template: `
    <app-page-header
      title="Client Booking Map"
      subtitle="Procedure-first booking prototype for client-friendly availability"
    />

    <app-appointment-create-flow
      [forceClientIntentMode]="true"
      [navigateOnSuccess]="true"
    />
  `,
})
export class AppointmentClientIntentMapPageComponent {}
